"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rtlLanguages = exports.CetComponentsProvider = exports.CetComponentsContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const defaultValues = {
  fontFamily: 'AlmoniNeue',
  basicFontSize: '16',
  siteKey: '',
  siteName: '',
  hostKey: '',
  language: 'he',
  rootFontSize: 10,
  isUpdateFontSizeOnResizeEnabled: true,
  mobileBreakpoint: 768,
  themeColors: {
    general: {
      light: '#ffffff',
      text: '#383745',
      subText: '#6d6d6d',
      border: '#e0e0e0',
      success: '#02C971',
      alert: '#D6434D'
    },
    basic: {
      main: '#ececf0',
      dark: '#64636d',
      light: '#f7f7f9',
      shadow: '#d0d0d0',
      start: '#ececf0',
      end: '#d0d0d0'
    },
    primary: {
      main: '#5750fa',
      dark: '#6C68BA',
      light: '#ECEBFF',
      shadow: 'rgba(87, 80, 250, 0.2)',
      start: '#5750fa',
      end: '#1e5afe',
      shade1: '#E2E2F7',
      shade2: '#DDDCFE',
      shade3: '#C1BFEF',
      shade4: '#9793FA',
      shade5: '#7771FA'
    }
  },
  direction: 'rtl',
  opDirection: 'ltr'
};
const rtlLanguages = exports.rtlLanguages = ['he', 'ar'];
const CetComponentsContext = exports.CetComponentsContext = /*#__PURE__*/_react.default.createContext(defaultValues);
const CetComponentsProvider = _ref => {
  let {
    children,
    value
  } = _ref;
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)(value);
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)(value, true);
  let contextValue = {
    ...defaultValues
  };
  contextValue.fontFamily = value.language === 'ar' ? 'abraham' : 'AlmoniNeue';
  contextValue.basicFontSize = isMobileView ? pxToRem(18) : pxToRem(16);
  contextValue = {
    ...contextValue,
    ...value
  };
  contextValue.direction = rtlLanguages.includes(contextValue.language) ? 'rtl' : 'ltr';
  contextValue.opDirection = rtlLanguages.includes(contextValue.language) ? 'ltr' : 'rtl';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CetComponentsContext.Provider, {
    value: contextValue,
    children: children
  });
};
exports.CetComponentsProvider = CetComponentsProvider;